module.exports = __webpack_public_path__ + "img/Indonesia-3.5066a380.jpg";